import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';
import './EditarEquipamento.css';

const EditarEquipamento = ({ equipamento, onClose, onEquipamentoUpdated }) => {
  const [formData, setFormData] = useState({
    ip: '',
    endereco: '',
    numero: '',
    patrimonio: '',
    latitude: '',
    longitude: '',
    descricao_mk: '',
    bairro: '',
    server_name: '',
    ad_enabled: false,
    ad_image_url: '',
    ad_click_url: '',
    ad_delay_seconds: 5,
    session_timeout_minutes: 30
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (equipamento) {
      setFormData({
        ip: equipamento.ip || '',
        endereco: equipamento.endereco || '',
        numero: equipamento.numero || '',
        patrimonio: equipamento.patrimonio || '',
        latitude: equipamento.latitude || '',
        longitude: equipamento.longitude || '',
        descricao_mk: equipamento.descricao_mk || '',
        bairro: equipamento.bairro || '',
        server_name: equipamento.server_name || '',
        ad_enabled: !!equipamento.ad_enabled,
        ad_image_url: equipamento.ad_image_url || '',
        ad_click_url: equipamento.ad_click_url || '',
        ad_delay_seconds: equipamento.ad_delay_seconds || 5,
        session_timeout_minutes: equipamento.session_timeout_minutes || 30
      });
    }
  }, [equipamento]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    if (!formData.ip || !formData.endereco) {
      setError('IP e Endereço são campos obrigatórios.');
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        setError('Sessão expirada. Faça login novamente.');
        setLoading(false);
        setTimeout(() => {
          window.location.href = '/sysconect/adm-login';
        }, 1500);
        return;
      }

      const latitudeValue = formData.latitude && formData.latitude.toString().trim() !== ''
        ? parseFloat(formData.latitude.toString().trim().replace(',', '.'))
        : null;
      const longitudeValue = formData.longitude && formData.longitude.toString().trim() !== ''
        ? parseFloat(formData.longitude.toString().trim().replace(',', '.'))
        : null;

      const dataToSend = {
        ip: formData.ip.trim(),
        endereco: formData.endereco.trim(),
        numero: formData.numero && formData.numero.trim() !== '' ? formData.numero.trim() : null,
        patrimonio: formData.patrimonio && formData.patrimonio.trim() !== '' ? formData.patrimonio.trim() : null,
        latitude: latitudeValue,
        longitude: longitudeValue,
        descricao_mk: formData.descricao_mk && formData.descricao_mk.trim() !== '' ? formData.descricao_mk.trim() : null,
        bairro: formData.bairro && formData.bairro.trim() !== '' ? formData.bairro.trim() : null,
        server_name: formData.server_name && formData.server_name.trim() !== '' ? formData.server_name.trim() : null,
        ad_enabled: !!formData.ad_enabled,
        ad_image_url: formData.ad_image_url && formData.ad_image_url.trim() !== '' ? formData.ad_image_url.trim() : null,
        ad_click_url: formData.ad_click_url && formData.ad_click_url.trim() !== '' ? formData.ad_click_url.trim() : null,
        ad_delay_seconds: Number.isFinite(Number(formData.ad_delay_seconds)) ? Number(formData.ad_delay_seconds) : 5,
        session_timeout_minutes: Number.isFinite(Number(formData.session_timeout_minutes)) ? Number(formData.session_timeout_minutes) : 30
      };

      if (dataToSend.latitude !== null && (isNaN(dataToSend.latitude) || dataToSend.latitude < -90 || dataToSend.latitude > 90)) {
        setError('Latitude inválida. Deve estar entre -90 e 90.');
        setLoading(false);
        return;
      }

      if (dataToSend.longitude !== null && (isNaN(dataToSend.longitude) || dataToSend.longitude < -180 || dataToSend.longitude > 180)) {
        setError('Longitude inválida. Deve estar entre -180 e 180.');
        setLoading(false);
        return;
      }

      const response = await axios.put(
        `${API_URL}/api/equipamentos/${equipamento.id}`,
        dataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data) {
        setSuccess('Equipamento atualizado com sucesso!');
        setTimeout(() => {
          if (onEquipamentoUpdated) {
            onEquipamentoUpdated();
          }
          if (onClose) {
            onClose();
          }
        }, 1500);
      }
    } catch (error) {
      console.error('Erro ao atualizar equipamento:', error);

      if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
          setError('Sessão expirada. Faça login novamente.');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setTimeout(() => {
            window.location.href = '/sysconect/adm-login';
          }, 2000);
        } else {
          setError(error.response.data?.error || `Erro ${error.response.status}: ${error.response.statusText}`);
        }
      } else if (error.request) {
        setError('Erro de conexão. Verifique sua internet e tente novamente.');
      } else {
        setError(error.message || 'Erro ao atualizar equipamento. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="editar-equipamento">
      <div className="editar-header">
        <h1>Editar Equipamento</h1>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>

      <div className="editar-form-container">
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <form onSubmit={handleSubmit} className="editar-form">
          <div className="form-row">
            <div className="form-group">
              <label>IP *</label>
              <input
                type="text"
                name="ip"
                value={formData.ip}
                onChange={handleChange}
                required
                placeholder="192.168.1.1"
              />
            </div>

            <div className="form-group">
              <label>Endereço *</label>
              <input
                type="text"
                name="endereco"
                value={formData.endereco || ''}
                onChange={handleChange}
                required
                placeholder="Endereço completo"
                autoComplete="street-address"
                aria-label="Endereço"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Número</label>
              <input
                type="text"
                name="numero"
                value={formData.numero}
                onChange={handleChange}
                placeholder="123"
              />
            </div>

            <div className="form-group">
              <label>Patrimônio</label>
              <input
                type="text"
                name="patrimonio"
                value={formData.patrimonio}
                onChange={handleChange}
                placeholder="Patrimônio do equipamento"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Bairro</label>
              <input
                type="text"
                name="bairro"
                value={formData.bairro}
                onChange={handleChange}
                placeholder="Nome do bairro"
              />
            </div>

          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Latitude</label>
              <input
                type="text"
                inputMode="decimal"
                name="latitude"
                value={formData.latitude}
                onChange={handleChange}
                placeholder="-22.7306"
              />
            </div>

            <div className="form-group">
              <label>Longitude</label>
              <input
                type="text"
                inputMode="decimal"
                name="longitude"
                value={formData.longitude}
                onChange={handleChange}
                placeholder="-45.1247"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Descrição do MK</label>
            <textarea
              name="descricao_mk"
              value={formData.descricao_mk}
              onChange={handleChange}
              rows="3"
              placeholder="Descrição do equipamento Mikrotik"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Server Name (Hotspot)</label>
              <input
                type="text"
                name="server_name"
                value={formData.server_name}
                onChange={handleChange}
                placeholder="hotspot1"
              />
            </div>
            <div className="form-group">
              <label>Tempo de Sessão (min)</label>
              <input
                type="number"
                min="1"
                name="session_timeout_minutes"
                value={formData.session_timeout_minutes}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="checkbox-row">
              <input
                type="checkbox"
                name="ad_enabled"
                checked={formData.ad_enabled}
                onChange={handleChange}
              />
              Ativar propaganda para este equipamento
            </label>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>URL da Imagem</label>
              <input
                type="text"
                name="ad_image_url"
                value={formData.ad_image_url}
                onChange={handleChange}
                placeholder="https://..."
              />
            </div>
            <div className="form-group">
              <label>URL de Clique</label>
              <input
                type="text"
                name="ad_click_url"
                value={formData.ad_click_url}
                onChange={handleChange}
                placeholder="https://..."
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Tempo para Fechar (s)</label>
              <input
                type="number"
                min="1"
                name="ad_delay_seconds"
                value={formData.ad_delay_seconds}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={onClose} className="cancel-btn">
              Cancelar
            </button>
            <button type="submit" disabled={loading} className="submit-btn">
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditarEquipamento;
